import React from "react";
import LegacyContentImport from "../Components/LegacyContentImport";

function AdminDashboard() {
  return (
    <div>
      <h1>Админ-панель</h1>
      <p>Добро пожаловать в панель управления НАРАМЕД.</p>
      <LegacyContentImport />
    </div>
  );
}

export default AdminDashboard;
